<ng-container *ngIf="antwoordResultaat && antwoordResultaat.resultaat">
  <div data-hj-suppress>{{antwoordResultaat.resultaat.value}}</div>
</ng-container>